import _ from 'lodash';
export function highchartsTooltipDelay(H) {
    const timerId = {};
    const generatePointsUniqueKey = points => {
        const generatePointKey = point => {
            return `${point.category} ${point.series.name}: ${point.x} ${point.y}`;
        };
        const result = points.map(generatePointKey).join(', ');
        return result;
    };
    H.wrap(H.Tooltip.prototype, 'refresh', function (proceed) {
        var _a;
        let seriesName;
        if (Array.isArray(arguments[1])) {
            seriesName = generatePointsUniqueKey(arguments[1]);
        }
        else {
            seriesName = arguments[1].series.name;
        }
        const delayForDisplay = this.container && ((_a = this.container) === null || _a === void 0 ? void 0 : _a.innerText) !== ''
            ? 0
            : this.chart.options.tooltip.delayForDisplay;
        if (timerId[seriesName]) {
            clearTimeout(timerId[seriesName]);
            delete timerId[seriesName];
        }
        timerId[seriesName] = window.setTimeout(function () {
            const pointOrPoints = this.refreshArguments[0];
            const hoverPoint = this.chart.hoverPoint;
            if (pointOrPoints === this.chart.hoverPoint ||
                _.find(pointOrPoints, function (point) {
                    return point === hoverPoint;
                })) {
                proceed.apply(this.tooltip, this.refreshArguments);
            }
        }.bind({
            refreshArguments: Array.prototype.slice.call(arguments, 1),
            chart: this.chart,
            tooltip: this,
        }), delayForDisplay);
    });
}
//# sourceMappingURL=tooltip-delay.js.map